import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';

const dataStorage = {
    heading: '',
    region: '',
    date: '',
}

const todayBtn = document.querySelector('.datepicker__today');
const filtersShowBtn = document.querySelector('.filters-show-btn');
const filtersHideBtn = document.querySelector('.filters-close-icon');

// dropdown btns
const dropdownBtnHeadings = document.querySelector('#headings-dropdown-btn');
const dropdownBtnRegions = document.querySelector('#regions-dropdown-btn');

const filtersSidebar = document.querySelector('.filters-sidebar');
const searchBtn = document.querySelector('.datepicker__btn');

function toggleDropdownContent(e, id) {
    document.getElementById(id).classList.toggle("dropdown_show");
}

function toggleMenuHandler(e) {
    if (!e.target.matches('.dropdown__btn')
        && !e.target.matches('.dropdown__btn-icon')
        && !e.target.matches('.dropdown__btn-text')) {
        if (e.target.classList.contains('dropdown__item')) {
            const dropdownBtn = e.target.parentElement.parentElement.querySelector('button');

            // select option value
            if (dropdownBtn.id === 'headings-dropdown-btn')
                dataStorage.heading = e.target.dataset.value;

            if (dropdownBtn.id === 'regions-dropdown-btn')
                dataStorage.region = e.target.dataset.value;

            dropdownBtn.children[0].innerHTML = e.target.textContent;
            dropdownBtn.classList.add('dropdown__btn_selected');
        }
        const dropdowns = document.getElementsByClassName("dropdown__content");
        for (let i = 0; i < dropdowns.length; i++) {
            const openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('dropdown_show'))
                openDropdown.classList.remove('dropdown_show');
        }
    }
}

window.addEventListener('click', toggleMenuHandler);

// dropdown togglers
dropdownBtnHeadings.addEventListener('click', (e) => toggleDropdownContent(e, "headings-dropdown"));
dropdownBtnRegions.addEventListener('click', (e) => toggleDropdownContent(e, "regions-dropdown"));

// TODO: Translations
const picker = new AirDatepicker('#date', {
    inline: true,
    // locale: {
    //   // days: ["1", "2", "3", "4", "5", "6"],
    //   // daysShort: ["1", "2", "3", "4", "5", "6"],
    //   // months: ["1", "2", "3", "4", "5", "6"],
    // },
    navTitles: {
        days: '<i>MMMM </i> &nbsp; <strong> yyyy</strong> ',
        // months: 'Select month of <strong>yyyy</strong>'
    },
});

const handleSearchClick = (e) => {
    dataStorage.date = picker.lastSelectedDate || new Date();
    dataStorage.date.setDate(dataStorage.date.getDate() + 1);
}

searchBtn.addEventListener('click', handleSearchClick);
todayBtn.addEventListener('click', function () {
    picker.selectDate(new Date());
});

document.querySelector('#filter-button').addEventListener('click', function (e) {
    let tab_content = document.querySelector(`#filter-button`);
    let search = tab_content.dataset.search;
    if (search) {
        location.href = `/search/?search=${search}&category=${dataStorage.heading}&date=${JSON.stringify(dataStorage.date).slice(1, -1)}`
    } else {
        location.href = `/news/?category=${dataStorage.heading}&date=${JSON.stringify(dataStorage.date).slice(1, -1)}`
    }
});

filtersShowBtn.addEventListener('click', () => {
    filtersSidebar.style.display = 'block';
});

// filtersHideBtn.addEventListener('click', () => {
//   filtersSidebar.style.display = 'none';
// });